export {MaintenancePageConnected as MaintenancePage} from './MaintenancePage.connect';
